import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Loading } from "@/components/auth/RequireAuth";
import { OverviewPanel, PartnersPanel, ListingsPanel, DisputesPanel, PayoutsPanel, UsersPanel, AuditPanel } from "@/components/admin/AdminPanels";
import { useMe } from "@/context/MeContext";
import { useApi, errMsg } from "@/lib/api";

const ENDPOINTS = { overview: "/admin/overview", partners: "/admin/partners", listings: "/admin/listings", disputes: "/admin/disputes", payouts: "/admin/payouts", users: "/users", audit: "/admin/audit" };

export default function Admin() {
  const api = useApi();
  const { me } = useMe();
  const [d, setD] = useState(null);
  const load = useCallback(async () => {
    try {
      const entries = await Promise.all(Object.entries(ENDPOINTS).map(async ([k, url]) => [k, (await api.get(url)).data]));
      setD(Object.fromEntries(entries));
    } catch (e) { toast.error(errMsg(e)); }
  }, [api]);
  useEffect(() => { load(); }, [load]);
  if (!d) return <Loading />;
  const p = { api, reload: load };
  return (
    <div className="mx-auto max-w-7xl px-5 py-10 md:px-8" data-testid="admin-page">
      <div className="eyebrow text-secondary">GOSHA Ops</div>
      <h1 className="mt-2 text-4xl tracking-tight text-primary">Operations console</h1>
      <Tabs defaultValue="overview" className="mt-8">
        <TabsList className="flex h-auto flex-wrap justify-start gap-1 bg-transparent p-0">
          {[["overview", "Overview"], ["partners", "Partner verification"], ["listings", "Listing moderation"], ["disputes", "Disputes & refunds"], ["payouts", "Payout release"], ["users", "Users"], ["audit", "Audit log"]].map(([k, l]) => (
            <TabsTrigger key={k} value={k} className="rounded-full px-4 data-[state=active]:bg-primary data-[state=active]:text-white" data-testid={`admin-tab-${k}`}>{l}</TabsTrigger>
          ))}
        </TabsList>
        <TabsContent value="overview" className="mt-8"><OverviewPanel o={d.overview} /></TabsContent>
        <TabsContent value="partners" className="mt-8"><PartnersPanel items={d.partners} {...p} /></TabsContent>
        <TabsContent value="listings" className="mt-8"><ListingsPanel items={d.listings} {...p} /></TabsContent>
        <TabsContent value="disputes" className="mt-8"><DisputesPanel items={d.disputes} {...p} /></TabsContent>
        <TabsContent value="payouts" className="mt-8"><PayoutsPanel items={d.payouts} {...p} /></TabsContent>
        <TabsContent value="users" className="mt-8"><UsersPanel data={d.users} meId={me?.user_id} {...p} /></TabsContent>
        <TabsContent value="audit" className="mt-8"><AuditPanel items={d.audit} /></TabsContent>
      </Tabs>
    </div>
  );
}
